

































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import DateComponent from "@/components/common/Inputs/Date.vue";
import { AppConstants as _app } from "@/shared/app.constants";
import moment from 'moment';

@Component({
    components: {
        DateComponent
    }
})
export default class ReportTable extends Vue {
    @Action("showNotification", { namespace: 'application' }) notify: any;

    @Prop() title: string;
    @Prop() reportData;
    @Prop() editableStatus: Array<string>;
    @Prop() deleteStatus: Array<string>;
    @Prop({ default: false }) showLock: boolean;
    @Prop({ default: false }) readOnly: boolean;
    @Prop() startDate: string;
    @Prop() endDate: string;
    @Prop({ default: false }) disableToggle: boolean;
    periodKey: number = 1;
    @Prop() statusCode;
    @Prop() userTypeId?: number;
    auditor = _app.UserType.Auditor;
    leadPartner = _app.UserType.LeadPartner;

    mounted() { }

    // reporting frequency dropdown options
    reportingFrequency: any = [
        { dispalyText: 'Quarter', abbr: 'Q', value: 3 },
        { dispalyText: 'Half year', abbr: 'H', value: 6 },
        { dispalyText: 'Year', abbr: 'Y', value: 12 }
    ];

    minDate(source, index) {
        if (index >= 0 && this.reportData[index][source]) {
            let date = new Date(this.reportData[index][source]);
            return moment(date.setDate(date.getDate() + 1)).format('YYYY-MM-DD');
        } else {
            return moment(this.startDate).format('YYYY-MM-DD');
        }
    }

    setDate(doc) {
        let date = new Date(doc.startDate);

        let freq = this.reportingFrequency
            .find(x => x.abbr == doc.period)?.value || 3;

        if (!doc.endDate) {
            date = new Date(date.getFullYear(), date.getMonth() + freq, 0)
            doc.endDate = moment(date).format('YYYY-MM-DD');
        }

        if (!doc.dueDate) {
            date = new Date(date.getFullYear(), date.getMonth() + 2, 0)
            doc.dueDate = moment(date).format('YYYY-MM-DD');
        }
    }

    clearDate(value) {
        value = "";
    }

    onRemoveRow(index, doc) {
        this.reportData.splice(index, 1);
        this.periodKey += 1;
        this.$emit('input', true);
    }

    addEmptyRow() {
        this.reportData.push({});
        this.periodKey += 1;
        this.$emit('input', true);
    }

    isReadonly(status) {
        return status ? !this.editableStatus.includes(status) : false;
    }
}
